<template>
  <div v-if="device">
    <app-header :title="(originalName) ? 'Edit '+ originalName: 'New Device'" subtitle="Device">
      <b-button variant="primary" @click="save()">
        Save Changes
      </b-button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="4">
          <b-form name="editorForm">
            <b-form-group>
              <label>Type</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-select v-model="device.type_id" required>
                <b-form-select-option value="1">
                  Phone
                </b-form-select-option>
                <b-form-select-option value="2">
                  Tablet
                </b-form-select-option>
                <b-form-select-option value="3">
                  Watch
                </b-form-select-option>
                <b-form-select-option value="4">
                  Laptop
                </b-form-select-option>
                <b-form-select-option value="5">
                  Other
                </b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group>
              <label>Manufacturer</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-select v-model="device.manufacturer_id" required>
                <b-form-select-option v-for="manufacturer in manufacturers" :key="manufacturer.id" :value="manufacturer.id">
                  {{ manufacturer.name }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <!--Name-->
            <b-form-group>
              <label>Name</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="device.name"
                type="text"
                class="form-control"
                required
              ></b-form-input>
            </b-form-group>
            <!--thumbnail-->
            <b-form-group>
              <label>Thumbnail</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <FileInput v-model="device.thumbnail" required folder="device/thumbnail" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="8"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import FileInput from '@/components/FileInput';
import CancelButton from '@/components/CancelButton';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    FileInput,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      device: null,
      manufacturers: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.manufacturers = await $api.get('/v1/internal/manufacturers');
      if (this.$route.query.id) {
        this.device = await $api.get(`/v1/internal/devices/${this.$route.query.id}`);
        this.originalName = device.name;
      } else {
        this.device = {
          manufacturer_id: this.$route.query.manufacturer_id,
        };
      }
    },

    async save() {
      let device;
      if (this.device.id) {
        device = await $api.put(`/v1/internal/devices/${this.device.id}`, this.device);
      } else {
        device = await $api.post('/v1/internal/devices', this.device);
      }
      this.$router.push({
        name: 'device-detail',
        params: device,
      });
    },
  },
};
</script>
